import React,{useState, useEffect} from 'react';
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash"
import "./index.css"

import { Button, TextAreaField, InputSwitchField } from "../../../helpers";
import Steps from '../../../helpers/Steps';
import { Toast } from 'primereact/toast';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dialog } from "primereact/dialog";

import { 
    validateInputs, 
    sortArrayOfObjectsInAlphabeticalOrder, 
    checkPermissions,
    getDuplicatesInArray
} from '../../../utils'

import Loading from "../../../common/Loading"

import { CompanyBranchValidationSchema } from '../../../validation/companyBranchValidation';

import AddBranch from './Components/AddBranch';

import { 
    fetchCountries, 
    fetchPinCodes, 
    fetchStatus,
    fetchTDSSections,
    fetchApprovalSecondary,
    fetchApprovals,
    fetchClientSuccessManagers,
    fetchCompanyRoleHierarchyData,
    fetchCompanyTypes
} from '../../../services/redux/reducers/commonThunk';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import { getCompanyWithGSTIN } from '../../../services/api/company'
import { getStateDataByCountry } from '../../../services/api/state'
import { addCompanyBranchData, updateCompanyBranchStatus, updateCompanyBranchData } from '../../../services/api/companyBranch'
import { getCompanyCreditPeriodsData } from '../../../services/api/companyCreditPeriod';
import { getUserRolesByCompanyId, getBuyerReqKamsByBranchIds } from '../../../services/api/user';
import { getApprovalInstancesByCompanyId } from "../../../services/api/approvalInstances";

import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';


const AddCompanyBranch = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const jwtToken = Cookies.get('jwtTokenClient')
    
    const [creditPeriods, setCreditPeriods] = useState([])
    const [companyBranches, setcompanyBranches] = useState([])
    const [prevCompanyBranches, setPrevCompanyBranches] = useState([])
    const [companyData, setCompanyData] = useState({})
    const [userRoles, setUserRoles] = useState([])
    const [gstinList, setGSTINList] = useState([])
    const [stateList, setStateList] = useState([])
    const [visibleAddNewShippingAddr, setVisibleShippingAddress] = useState(false)
    const [formErrors, setFormErrors] = useState([]);
    const [validationBranchId, setValidationBranchId] = useState(null)
    const [selectedBranchId, setSelectedBranchId] = useState(null)
    const [isLoaderVisible, setIsLoaderVisible] = useState(true)
    const [activeIndex, setActiveIndex] = useState(0);
    const [prevUserRoles, setPrevUserRoles] = useState([])
    const [modifiedBranchId, setModifiedBranchId] = useState(null)
    const [prefPMStateList, setPrefPMStateList] = useState([])
    const [userName, setUserName] = useState(null)
    const [branchManagers, setBranchManagers] = useState([])
    const [visibleApprovalRemarks, setVisibleApprovalRemarks] = useState(false)
    const [paymentTermsApprovalRemarks, setPaymentTermsApprovalRemarks] = useState('')
    const [submitBranchData, setSubmitBranchData] = useState({})
    const [updateBranchObj, setUpdateBranchObj] = useState(null)
    const [ approvalInstancesData, setApprovalInstancesData] = useState([])
    const [companyLevelUsers, setCompanyLevelUsers] = useState([])
    const [relevantKams, setRelevantKams] = useState([])

    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const countriesData = useSelector(state => state.common.countries)
    const pinCodesData = useSelector(state => state.common.pinCodes)
    const userDetails = useSelector((state) => state.userDetails)

    const approvals = useSelector((state) => state.common.approvals)
    const clientSuccessManagers = useSelector(state => state.common.clientSuccessManagers)
    const companyRoleHierarchy = useSelector(state => state.common.companyRoleHierarchy)
    const companyTypes = useSelector((state) => state.common.companyTypes)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    
    useEffect(() => {
        if (jwtToken) {
            dispatch(fetchCountries())
            dispatch(fetchPinCodes())
            dispatch(fetchStatus())
            dispatch(fetchTDSSections())
            dispatch(fetchApprovalSecondary())
            dispatch(fetchApprovals())
            dispatch(fetchClientSuccessManagers())
            dispatch(fetchCompanyRoleHierarchyData())
            dispatch(fetchCompanyTypes())
        }
    }, [])

    useEffect(() => {
        if(approvals.length){
            initialiseData()
        }
    }, [approvals])

    const items = [
        {
            label: 'Company Details',
            command: () => { navigate(`/company/${id}`) }
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); } 
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); } 
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); }
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); }
        }
    ]

    if([2, 3].includes(companyData?.buyerSeller)){
        items.push(
            {
                label: 'Seller Profile',
                command: () => { navigate(`/company/seller-profile/${id}`); } 
            }
        )
    }

    const initialiseData = async () => {
        await getCompnayData()
        let response = await getCompanyCreditPeriodsData({sortOrder:"ASC", paginator: false})
        let creditPeriods = response.data.data 
        if(creditPeriods){
            creditPeriods.sort((objA, objB) => objA.creditPeriod - objB.creditPeriod)
        }
        setCreditPeriods(creditPeriods)
        getUsersData()
    }

    const getUsersData = async () => {
        const data = { 
            companyId: id,
            userStatusId: 1
        }
        const userRolesResponse = await getUserRolesByCompanyId(data)

        if (userRolesResponse.failure){
            setIsLoaderVisible(false)
            return dispatch(raiseToast({ severity: 'error', detail: userRolesResponse.data?.error, life: 3000 }))
        }else{
            let userRolesData = userRolesResponse?.data?.filter(eachUser => eachUser.branchId !== 0)
            let companyLevelUserRolesData = userRolesResponse?.data?.filter(eachUser => eachUser.branchId == 0 && eachUser.statusId === 1)
                .sort((userA, userB) => {
                    if (userA.user.firstName < userB.user.firstName){
                        return -1
                    }
                    if (userA.user.firstName > userB.user.firstName){
                        return 1
                    }
                    return 0
                })
            
            let uniqueCompanyLevelUsers = []
            if (companyLevelUserRolesData.length) {
                uniqueCompanyLevelUsers = _.uniqBy(companyLevelUserRolesData, userRole => userRole.user.userId)
                    .map(userRole => userRole.user)
            }
            
            setCompanyLevelUsers([...uniqueCompanyLevelUsers])
            setUserRoles([...userRolesResponse.data])
            setPrevUserRoles(JSON.parse(JSON.stringify(userRolesData)))
        }
    }

    const getCompnayData = async () => {
        const company_id = id
        const companyData = await getCompanyWithGSTIN(company_id)
        if(companyData.status = 1){
            const company_data = companyData.data
            // console.log("companyData-response",company_data)
            if(company_data){
                getStateList(company_data?.countryId)

                let updatedBranchUsers = company_data.companyUsers.map((eachUser) => {
                    if(eachUser?.firstName && eachUser?.lastName){
                        return {
                            ...eachUser,
                            firstName: `${eachUser.firstName} ${eachUser.lastName}`
                        }
                    }else{
                        return {
                            ...eachUser
                        }
                    }
                })

                setBranchManagers(updatedBranchUsers)

                company_data.companyUsers = updatedBranchUsers

                let sortedGSTINs = sortArrayOfObjectsInAlphabeticalOrder(company_data?.companyGSTIN, "gstinCode")
                sortedGSTINs = sortedGSTINs.filter(eachGSTIN => eachGSTIN.gstinCode)
                setGSTINList(sortedGSTINs)

                const hodUser = company_data?.companyUsers?.find(obj => obj.userId == company_data.companyHOD)
                company_data.hodUser = hodUser

                company_data.companyRoles = company_data.companyRoles.filter(eachRole => eachRole.companyRoleName !== "HOD")
                
                setCompanyData(company_data)

                let branchIds = []
                company_data.companyBranches.map(branch=>{
                    branchIds.push(branch.branchId)
                    if(branch.vmiEnabled){
                        branch.vmiEnabled = "Yes"
                    }
                    else{
                        branch.vmiEnabled = "No"
                    }

                    if(!branch.paymentTerms){
                        if(typeof company_data.paymentTerms === 'string'){
                            branch.paymentTerms = JSON.parse(company_data.paymentTerms)
                        }else{
                            branch.paymentTerms = company_data.paymentTerms
                        }

                        branch.companyPaymentTerms = true
                                   
                    }else{
                        if(branch.paymentTerms && typeof branch.paymentTerms === 'string'){
                            branch.paymentTerms = JSON.parse(branch.paymentTerms)
                        } 
                    }

                    let relatedBranchShipAddr = company_data.companyBranchShipAddrs.filter(addr => addr.branchId === branch.branchId)
                    let primaryShipAddr = relatedBranchShipAddr.filter(eachAddr => eachAddr.shipAddrId === branch.primaryShipAddrId)
                    let notPrimaryShipAddrs = relatedBranchShipAddr.filter(eachAddr => eachAddr.shipAddrId !== branch.primaryShipAddrId)

                    branch.shipAddrArr = [...primaryShipAddr, ...notPrimaryShipAddrs]
                })

                const sortedCompanyBranches = sortArrayOfObjectsInAlphabeticalOrder(company_data.companyBranches, "branchName")

                setcompanyBranches(sortedCompanyBranches)
                setPrevCompanyBranches(sortedCompanyBranches)
                getApprovalInstances()
                getRelevantBranchKams(branchIds)
            }
        }
        setIsLoaderVisible(false)
    }

    const getRelevantBranchKams = async(branchIds) => {
        setIsLoaderVisible(true)
        const response = await getBuyerReqKamsByBranchIds({branchIds})
        setIsLoaderVisible(false)
        if (response.failure){
            return dispatch(raiseToast({ severity: 'error', detail: response.data?.error, life: 3000 }))
        }

        if(response.data && response.data.length){
            let sortedRelevantKams = sortArrayOfObjectsInAlphabeticalOrder(response.data, "firstName")
            setRelevantKams([...sortedRelevantKams])
        }
    }

    const getStateList = async (country_id) => {
        const stateData = await getStateDataByCountry(country_id)
        if(stateData.status == 1){
            const stateList = sortArrayOfObjectsInAlphabeticalOrder(stateData.data, "stateName")
            setStateList(stateList)
            
            let relatedPrefPMStates = stateList.filter(state=>{
                return pmCompanyDetails?.companyBillAddrs?.find(addrs => addrs.stateId === state.stateId)
            })
            setPrefPMStateList(relatedPrefPMStates)
        }
    }

    const getApprovalInstances = async() => {
        let data = {
            companyType: "sellerCompanyId",
            isBranchPaymentTerms: true
        }
        const approvalInstancesResponse = await getApprovalInstancesByCompanyId(id, data)

        if (approvalInstancesResponse?.failure){
            return dispatch(raiseToast({ severity: 'error', detail: approvalInstancesResponse?.data?.error, life: 3000 }))
        }else{

            let relatedBranchPaymentTermsApprovalInstances = approvalInstancesResponse.data.filter(eachInstance => {
                const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === eachInstance.approvalId)
                if (pmCompanyConfig.branchPaymentTermsApprovalTypeIds.includes(relatedApproval.approvalTypeId)){
                    return true
                }
                return false
            })
            setApprovalInstancesData([...relatedBranchPaymentTermsApprovalInstances])
        }
    }

    const handleAddNewCompanyBranch = async(branchData) => {
        let relatedBrandData = companyBranches.find(eachBranch => eachBranch.branchId != branchData.branchId && eachBranch.branchName?.toLowerCase() === branchData.branchName.toLowerCase())
        if(relatedBrandData){
            return dispatch(raiseToast({ severity: "warn", detail: `Branch ${relatedBrandData.branchName} already exists`, life: 3000 }))
        }

        setValidationBranchId(branchData.branchId)

        const relatedUserRoles = userRoles.filter(eachRole => eachRole.branchId === branchData.branchId)
        
        branchData.userRoles = relatedUserRoles 
        branchData.companyBuyerSeller = companyData.buyerSeller
        branchData.isInternational = pmCompanyConfig.isInternational
        branchData.pmCompanyId = pmCompanyDetails.companyId
        
        const validation_res = await validateInputs(CompanyBranchValidationSchema, branchData)
        
        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
                Object.keys(validation_res.error).map(eachError => {
                    dispatch(raiseToast({ severity: 'warn', detail: validation_res.error[eachError], life: 3000 }))
                })
            }
            else {
                setFormErrors({})
                let branchGSTINs = []
                if(companyData?.companyGSTIN?.length > 0){
                    companyData.companyGSTIN.map(eachGSTIN => {
                        branchGSTINs.push(eachGSTIN.gstinCode)
                    })
                }
                let updateBranchObj = {
                    "branchName": validation_res.result.branchName,
                    "branchType": validation_res.result.branchType,
                    "vmiEnabled": validation_res.result.vmiEnabled,
                    "branchGSTINs": branchGSTINs?.length > 0 ? branchGSTINs : null,
                    "prefPMBranchId": validation_res.result.prefPMBranchId,
                    "prefPMStateId": 1,
                    "prefPMBankId": validation_res.result.prefPMBankAccId,
                    "prefPMStateId": validation_res.result.prefPMStateId,
                    "companyId": validation_res.result.companyId,
                    "statusId": validation_res.result.statusId,
                    "primaryShipAddrId": validation_res.result.primaryShipAddrId,
                    "shipAddrArr": validation_res.result.shipAddrArr,
                    "userRoles": validation_res.result.userRoles,
                    "buyerSeller": validation_res.result.buyerSeller,
                    "clientSuccessManagerId": validation_res.result.clientSuccessManagerId,
                    "companyBuyerSeller": companyData.buyerSeller
                }

                if (branchData.companyPaymentTerms) {
                    updateBranchObj.paymentTerms = null
                } else {
                    if (branchData.paymentTerms) {
                        let total_payment_percentage = 0
                        if (branchData.paymentTerms?.payAdvPO || branchData.paymentTerms?.payAdvDelivery || branchData.paymentTerms?.payPDCDelivery || branchData.paymentTerms?.payOnDelivery || branchData.paymentTerms?.payCredit) {
                            if (branchData.paymentTerms?.payAdvPO) {
                                branchData.paymentTerms.payAdvPO = parseFloat(branchData.paymentTerms.payAdvPO)
                                total_payment_percentage += branchData.paymentTerms.payAdvPO
                            }else{
                                branchData.paymentTerms.payAdvPO = 0
                            }

                            if (branchData.paymentTerms?.payAdvDelivery) {
                                branchData.paymentTerms.payAdvDelivery = parseFloat(branchData.paymentTerms.payAdvDelivery)
                                total_payment_percentage += branchData.paymentTerms.payAdvDelivery
                            }else{
                                branchData.paymentTerms.payAdvDelivery = 0
                            }
                    
                            if (branchData.paymentTerms?.payOnDelivery) {
                                branchData.paymentTerms.payOnDelivery = parseFloat(branchData.paymentTerms.payOnDelivery)
                                total_payment_percentage += branchData.paymentTerms.payOnDelivery
                            }else{
                                branchData.paymentTerms.payOnDelivery = 0
                            }

                            if ((branchData.paymentTerms?.payCredit && branchData.paymentTerms?.payCredit != 0) || (branchData.paymentTerms?.payPDCDelivery && branchData.paymentTerms?.payPDCDelivery != 0)) {
                                if (branchData.paymentTerms?.payCredit && branchData.paymentTerms?.payCredit != 0) {
                                    branchData.paymentTerms.payCredit = parseFloat(branchData.paymentTerms.payCredit)
                                    total_payment_percentage += branchData.paymentTerms.payCredit
                                }else{
                                    branchData.paymentTerms.payCredit = 0
                                }

                                if (branchData.paymentTerms?.payPDCDelivery && branchData.paymentTerms?.payPDCDelivery != 0) {
                                    branchData.paymentTerms.payPDCDelivery = parseFloat(branchData.paymentTerms.payPDCDelivery)
                                    total_payment_percentage += branchData.paymentTerms.payPDCDelivery
                                }else{
                                    branchData.paymentTerms.payPDCDelivery = 0
                                }

                                if (!branchData.paymentTerms?.creditPeriodId) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select credit period", life: 3000 }))
                                }
                            } else {
                                branchData.paymentTerms.payPDCDelivery = 0
                                branchData.paymentTerms.payCredit = 0
                                delete branchData.paymentTerms.creditPeriodId
                            }
                        }
                        
                        if (branchData.paymentTerms?.payAdvPO || branchData.paymentTerms?.payAdvDelivery || branchData.paymentTerms?.payPDCDelivery || branchData.paymentTerms?.payOnDelivery || branchData.paymentTerms?.payCredit) {
                            if (total_payment_percentage !== 100) {
                                return dispatch(raiseToast({ severity: 'warn', detail: "Total percentage of payment terms should be 100", life: 3000 }))
                            }
                        }
                    }
                    else {
                        return dispatch(raiseToast({ severity: 'warn', detail: "Please enter payment terms", life: 3000 }))
                    }

                    updateBranchObj.paymentTerms = branchData.paymentTerms
                }

                if(branchData.branchGSTINs?.length === 0){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select branch gstins", life: 3000 }))
                }else{
                    let isAllInactiveGSTINsSelected = branchData.branchGSTINs.every(gstinCode => {
                        const gstinDetails = gstinList.find(eachGSTIN => eachGSTIN.gstinCode === gstinCode)
                        return gstinDetails && gstinDetails.statusId === 2
                    })

                    if(isAllInactiveGSTINsSelected){
                        return dispatch(raiseToast({ severity: 'warn', detail: "At least one active GSTIN must be selected.", life: 3000 }))
                    }
                }


                if(branchData.shipAddrArr?.length === 0){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please enter shipping address", life: 3000 }))
                }

                if(!branchData.primaryShipAddrId){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select primary shipping address", life: 3000 }))
                }

                if (branchData?.userRoles?.length === 0) {

                } else {
                    let companyRoleHierarchyCompanyIds = _.uniqBy(companyRoleHierarchy, 'companyId').map(obj => obj.companyId)
                    if (companyRoleHierarchyCompanyIds.includes(parseInt(id))) {
                        let companyBranchHeadUsers = []
                        let companyRegionalHeadUsers = []
                        let companySeniorKamUsers = []
                        if (branchData?.userRoles && branchData?.userRoles?.length > 0) {
                            let relatedBranchHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 3)
                            let relatedRegionalHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 13)
                            let relatedSeniorKamRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 14)
                            
                            branchData?.userRoles?.map(eachUser => {
                                if (eachUser.statusId === 1) {
                                    if (eachUser?.companyRoleId === relatedBranchHeadRole?.companyRoleId) {
                                        companyBranchHeadUsers.push(eachUser)
                                    }

                                    if (eachUser?.companyRoleId === relatedRegionalHeadRole?.companyRoleId) {
                                        companyRegionalHeadUsers.push(eachUser)
                                    }

                                    if (eachUser?.companyRoleId === relatedSeniorKamRole?.companyRoleId) {
                                        companySeniorKamUsers.push(eachUser)
                                    }
                                }
                            })

                            const isCompanyRoleAssignedForAllUserRoles = branchData?.userRoles?.every(eachRole => eachRole.companyRoleId)
                            if(!isCompanyRoleAssignedForAllUserRoles) {
                                return dispatch(raiseToast({ severity: 'error', detail: "Please add roles to all users" }))
                            }
                        }

                        if (!companyBranchHeadUsers.length) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Please add branch head user" }))
                        }

                        if (companyBranchHeadUsers.length > 1) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only have one Branch Head" }))
                        }

                        if (companyRegionalHeadUsers.length > 1) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only 1 Regional Head" }))
                        }

                        if (companySeniorKamUsers.length === 0) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have atleast 1 SR Kam" }))
                        }
                    }
                }

                let confirmMessage = "Do you want to add new branch..?"

                let approvalConfirmMessage = ""
                if([2, 3].includes(companyData.buyerSeller)){
                    let relatedCompanyBranchesPaymentTermsApproval = approvals.find(eachApproval => eachApproval.approvalTypeId === 13 && eachApproval.statusId === 1) // APPROVAL_CHANGE find by approvalTYpeId
                    if(relatedCompanyBranchesPaymentTermsApproval){
                        updateBranchObj.isPaymentTermsApproval = handlePaymentTermsApproval(updateBranchObj.paymentTerms, companyData.paymentTerms)
                    }
                }

                if(!updateBranchObj.isPaymentTermsApproval){
                    updateBranchObj.isPaymentTermsChanged = true
                    updateBranchObj.previousPaymentTerms = null
                }
                
                if (updateBranchObj.isPaymentTermsApproval) {
                    approvalConfirmMessage +=  "This needs approval from payments team before seller PO created."
                    if(window.confirm(approvalConfirmMessage)){
                        setSubmitBranchData({ ...updateBranchObj, confirmMessage, branchId: branchData.branchId })
                        setVisibleApprovalRemarks(true)
                    }
                } else{
                    if (window.confirm(confirmMessage)) {
                        setIsLoaderVisible(true)
                        let addNewBranchData = await addCompanyBranchData(updateBranchObj)
                        console.log("updatedBranchData-Response", addNewBranchData)
                        if (addNewBranchData?.failure){
                            setIsLoaderVisible(false)
                            return dispatch(raiseToast({ severity: 'error', detail: addNewBranchData?.data?.error, life: 3000 }))
                        }
                        if (addNewBranchData.status === 200) {
                            let newBranchData = addNewBranchData.data.companyBranchData
    
                            newBranchData.shipAddrArr = addNewBranchData.data.companyBranchShipAddr
    
                            if (newBranchData.vmiEnabled) {
                                newBranchData.vmiEnabled = "Yes"
                            }
                            else {
                                newBranchData.vmiEnabled = "No"
                            }
    
                            if (!newBranchData.paymentTerms) {
                                newBranchData.companyPaymentTerms = true
                                if(typeof companyData.paymentTerms === 'string'){
                                    newBranchData.paymentTerms = JSON.parse(companyData.paymentTerms)
                                }else{
                                    newBranchData.paymentTerms = companyData.paymentTerms
                                }
                            } else {
                                if (newBranchData.paymentTerms && typeof newBranchData.paymentTerms === 'string') {
                                    newBranchData.paymentTerms = JSON.parse(newBranchData.paymentTerms)
                                }
                            }
                            
                            let relatedCompanyBranches = companyBranches.filter(branch => branch.branchId != branchData.branchId)
    
                            setcompanyBranches([...relatedCompanyBranches, newBranchData])
                            setPrevCompanyBranches([...relatedCompanyBranches, newBranchData])
    
                            let newUserRoles = addNewBranchData?.data?.userRoles
    
                            newUserRoles?.map(role => {
                                let relatedUser = companyData.companyUsers.find(user => user.userId === role.userId)
                                if (relatedUser) {
                                    role.user = relatedUser
                                }
                                return role
                            })
    
                            let relatedCompanyUserRoles = userRoles?.filter(branch => branch.branchId != branchData.branchId)
    
                            if(newUserRoles && newUserRoles?.length > 0){
                                setUserRoles([...relatedCompanyUserRoles, ...newUserRoles])
                                setPrevUserRoles([...relatedCompanyUserRoles, ...newUserRoles])
                            }else{
                                setUserRoles([...relatedCompanyUserRoles])
                                setPrevUserRoles([...relatedCompanyUserRoles])
                            }
    
                            dispatch(raiseToast({ severity: 'success', detail: "New Branch added successfully" }))
                        }
                        setIsLoaderVisible(false)
                    }
                }
            }
        }
    }

    const handleSubmitNewBranchWithApproval = async () => {

        if (submitBranchData.isPaymentTermsApproval && (!paymentTermsApprovalRemarks || (paymentTermsApprovalRemarks && paymentTermsApprovalRemarks?.trim() === ''))){
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter payment terms approval remarks", life: 3000 }))
        }

        submitBranchData.paymentTermsApprovalRemarks = paymentTermsApprovalRemarks.trim()

        if (window.confirm("Do you want to add new branch..?")) {
            setIsLoaderVisible(true)
            let addNewBranchData = await addCompanyBranchData(submitBranchData)
            console.log("addNewBranchData-Response", addNewBranchData)
            if (addNewBranchData?.failure){
                setIsLoaderVisible(false)
                return dispatch(raiseToast({ severity: 'error', detail: addNewBranchData?.data?.error, life: 3000 }))
            }
            if (addNewBranchData.status === 200) {
                let newBranchData = addNewBranchData.data.companyBranchData

                newBranchData.shipAddrArr = addNewBranchData.data.companyBranchShipAddr

                if (newBranchData.vmiEnabled) {
                    newBranchData.vmiEnabled = "Yes"
                }
                else {
                    newBranchData.vmiEnabled = "No"
                }

                if (!newBranchData.paymentTerms) {
                    newBranchData.companyPaymentTerms = true
                    if(typeof companyData.paymentTerms === 'string'){
                        newBranchData.paymentTerms = JSON.parse(companyData.paymentTerms)
                    }else{
                        newBranchData.paymentTerms = companyData.paymentTerms
                    }
                } else {
                    if (newBranchData.paymentTerms && typeof newBranchData.paymentTerms === 'string') {
                        newBranchData.paymentTerms = JSON.parse(newBranchData.paymentTerms)
                    }
                }
                
                let relatedCompanyBranches = companyBranches.filter(branch => branch.branchId != submitBranchData.branchId)

                setcompanyBranches([...relatedCompanyBranches, newBranchData])
                setPrevCompanyBranches([...relatedCompanyBranches, newBranchData])

                let newUserRoles = addNewBranchData?.data?.userRoles

                newUserRoles?.map(role => {
                    let relatedUser = companyData.companyUsers.find(user => user.userId === role.userId)
                    if (relatedUser) {
                        role.user = relatedUser
                    }
                    return role
                })

                let relatedCompanyUserRoles = userRoles?.filter(branch => branch.branchId != submitBranchData.branchId)

                if(newUserRoles && newUserRoles?.length > 0){
                    setUserRoles([...relatedCompanyUserRoles, ...newUserRoles])
                    setPrevUserRoles([...relatedCompanyUserRoles, ...newUserRoles])
                }else{
                    setUserRoles([...relatedCompanyUserRoles])
                    setPrevUserRoles([...relatedCompanyUserRoles])
                }

                dispatch(raiseToast({ severity: 'success', detail: "New Branch added successfully" }))
            }
            getApprovalInstances()
            setVisibleApprovalRemarks(false)
            setPaymentTermsApprovalRemarks("")
            setIsLoaderVisible(false)
        }
    }

    const handleUpdateCompanyBranch = async(branchData) => {

        let relatedBrandData = companyBranches.find(eachBranch => eachBranch.branchId !== branchData.branchId && eachBranch.branchName?.toLowerCase() === branchData.branchName.toLowerCase())
        if(relatedBrandData){
            return dispatch(raiseToast({ severity: "warn", detail: `Branch ${relatedBrandData.branchName} already exists`, life: 3000 }))
        }

        setValidationBranchId(branchData.branchId)
        
        const relatedUserRoles = userRoles.filter(eachRole => eachRole.branchId === branchData.branchId)
        branchData.userRoles = relatedUserRoles 
        branchData.isInternational = pmCompanyConfig.isInternational
        branchData.companyBuyerSeller = companyData.buyerSeller
        branchData.pmCompanyId = pmCompanyDetails.companyId

        const validation_res = await validateInputs(CompanyBranchValidationSchema, branchData)
        if (validation_res) {
            if (validation_res.error) {
                setFormErrors(validation_res.error)
                Object.keys(validation_res.error).map(eachError => {
                    dispatch(raiseToast({ severity: 'warn', detail: validation_res.error[eachError], life: 3000 }))
                })
            }
            else {
                setFormErrors({})
                let updateBranchObj = {...validation_res.result}
                delete updateBranchObj.isEditing
                
                if (branchData.companyPaymentTerms) {
                    updateBranchObj.paymentTerms = null
                } else {
                    if (branchData.paymentTerms) {
                        let total_payment_percentage = 0
                        if (branchData.paymentTerms?.payAdvPO || branchData.paymentTerms?.payAdvDelivery || branchData.paymentTerms?.payPDCDelivery || branchData.paymentTerms?.payOnDelivery || branchData.paymentTerms?.payCredit) {
                            if (branchData.paymentTerms?.payAdvPO) {
                                branchData.paymentTerms.payAdvPO = parseFloat(branchData.paymentTerms.payAdvPO)
                                total_payment_percentage += branchData.paymentTerms.payAdvPO
                            }else{
                                branchData.paymentTerms.payAdvPO = 0
                            }

                            if (branchData.paymentTerms?.payAdvDelivery) {
                                branchData.paymentTerms.payAdvDelivery = parseFloat(branchData.paymentTerms.payAdvDelivery)
                                total_payment_percentage += branchData.paymentTerms.payAdvDelivery
                            }else{
                                branchData.paymentTerms.payAdvDelivery = 0
                            }
                            
                            if (branchData.paymentTerms?.payOnDelivery) {
                                branchData.paymentTerms.payOnDelivery = parseFloat(branchData.paymentTerms.payOnDelivery)
                                total_payment_percentage += branchData.paymentTerms.payOnDelivery
                            }else{
                                branchData.paymentTerms.payOnDelivery = 0
                            }
                            

                            if ((branchData.paymentTerms?.payCredit && branchData.paymentTerms?.payCredit != 0) || (branchData.paymentTerms?.payPDCDelivery && branchData.paymentTerms?.payPDCDelivery != 0)) {
                                if (branchData.paymentTerms?.payCredit && branchData.paymentTerms?.payCredit != 0) {
                                    branchData.paymentTerms.payCredit = parseFloat(branchData.paymentTerms.payCredit)
                                    total_payment_percentage += branchData.paymentTerms.payCredit
                                }else{
                                    branchData.paymentTerms.payCredit = 0
                                }
                                
                                if (branchData.paymentTerms?.payPDCDelivery && branchData.paymentTerms?.payPDCDelivery != 0) {
                                    branchData.paymentTerms.payPDCDelivery = parseFloat(branchData.paymentTerms.payPDCDelivery)
                                    total_payment_percentage += branchData.paymentTerms.payPDCDelivery
                                }else{
                                    branchData.paymentTerms.payPDCDelivery = 0
                                }
                                
                                if (!branchData.paymentTerms?.creditPeriodId) {
                                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select credit period", life: 3000, }))
                                }
                            } else {
                                branchData.paymentTerms.payPDCDelivery = 0
                                branchData.paymentTerms.payCredit = 0
                                delete branchData.paymentTerms.creditPeriodId
                            }
                        }

                        if (total_payment_percentage !== 100) {
                            return dispatch(raiseToast({ severity: 'warn', detail: "Total percentage of payment terms should be 100", life: 3000, }))
                        }
                    }
                    else {
                        return dispatch(raiseToast({ severity: 'success', detail: "Please enter payment terms", life: 3000, }))
                    }
                    
                    updateBranchObj.paymentTerms = JSON.stringify(branchData.paymentTerms)
                }

                if(branchData.branchGSTINs?.length === 0){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select branch gstins", life: 3000 }))
                }else{
                    let isAllInactiveGSTINsSelected = branchData.branchGSTINs.every(gstinCode => {
                        const gstinDetails = gstinList.find(eachGSTIN => eachGSTIN.gstinCode === gstinCode)
                        return gstinDetails && gstinDetails.statusId === 2
                    })

                    if(isAllInactiveGSTINsSelected){
                        return dispatch(raiseToast({ severity: 'warn', detail: "At least one active GSTIN must be selected.", life: 3000 }))
                    }
                }

                if(branchData.shipAddrArr?.length === 0){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please enter shipping address", life: 3000 }))
                }

                let primaryShipAddr = branchData.shipAddrArr.find(eachShipAddr => eachShipAddr.shipAddrId === branchData.primaryShipAddrId)
                if(!branchData.primaryShipAddrId || !primaryShipAddr){
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please select primary shipping address", life: 3000 }))
                }

                let relatedPrevBranchData = prevCompanyBranches.find(branch => branch.branchId === updateBranchObj.branchId)
                
                let relatedPrevBranchPaymentTerms = null
                if(relatedPrevBranchData){
                    relatedPrevBranchData = {...relatedPrevBranchData}
                    if(branchData.companyPaymentTerms){
                        relatedPrevBranchPaymentTerms = relatedPrevBranchData.paymentTerms
                        relatedPrevBranchData.paymentTerms = null
                    }
                    
                    if(updateBranchObj.vmiEnabled){
                        relatedPrevBranchData.vmiEnabled = true
                    }else{
                        relatedPrevBranchData.vmiEnabled = false
                    }
                }


                let prevBranchData = JSON.parse(JSON.stringify(relatedPrevBranchData))
                let newBranchData = JSON.parse(JSON.stringify(updateBranchObj))

                let prevShipAddrArr = relatedPrevBranchData?.shipAddrArr
                let shipAddrArr = updateBranchObj?.shipAddrArr

                let updateCompanyBranchShipAddr = []
                shipAddrArr?.map(shipAddr => {
                    if (shipAddr.isNew) {
                        updateCompanyBranchShipAddr.push(shipAddr)
                    }
                    else {
                        let relatedPrevShipAddr = JSON.stringify(prevShipAddrArr.find(prevShipAddr => prevShipAddr.shipAddrId === shipAddr.shipAddrId))
                        let updatedShipAddr = JSON.stringify(shipAddr)

                        if (updatedShipAddr !== relatedPrevShipAddr) {
                            updateCompanyBranchShipAddr.push(JSON.parse(updatedShipAddr))
                        }
                    }
                })

                const relatedPrevUserRoles = prevUserRoles.filter(eachRole => eachRole.branchId === branchData.branchId)
                
                let updatedBranchUserRoles = updateBranchObj?.userRoles

                let relatedBranchHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 3)
                let relatedRegionalHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 13)
                let relatedSeniorKamRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === 14)

                let updateCompanyUserRoles = []
                let companyBranchHeadUsers = []
                let companyRegionalHeadUsers = []
                let companySeniorKamUsers = []
                // let updatedCompanyUsers = []

                
                const isCompanyRoleAssignedForAllUserRoles = updatedBranchUserRoles.every(eachRole => eachRole.companyRoleId)
                if(!isCompanyRoleAssignedForAllUserRoles) {
                    return dispatch(raiseToast({ severity: 'error', detail: "Please add roles to all users" }))
                }

                updatedBranchUserRoles.map(eachUserRole => {
                    let relatedPrevCompanyUser = relatedPrevUserRoles?.find(prevUser => prevUser.userId === eachUserRole.userId && prevUser.userRoleId === eachUserRole.userRoleId)
                    // if(relatedPrevCompanyUser?.statusId !== eachUserRole?.user?.statusId){
                    //     updatedCompanyUsers.push(eachUserRole.user)
                    // }
                    if(eachUserRole.statusId === 1){
                        if(eachUserRole?.companyRoleId === relatedBranchHeadRole?.companyRoleId){
                            companyBranchHeadUsers.push(eachUserRole)
                        }
                        if(eachUserRole?.companyRoleId === relatedRegionalHeadRole?.companyRoleId){
                            companyRegionalHeadUsers.push(eachUserRole)
                        }
                        if(eachUserRole?.companyRoleId === relatedSeniorKamRole?.companyRoleId){
                            companySeniorKamUsers.push(eachUserRole)
                        }
                    }
                    if (eachUserRole.isNew) {
                        updateCompanyUserRoles.push(eachUserRole)
                    }
                    else {                        
                        relatedPrevCompanyUser = JSON.stringify(relatedPrevCompanyUser)
                        let newCompanyUser = JSON.stringify(eachUserRole)
                        if (relatedPrevCompanyUser !== newCompanyUser) {
                            updateCompanyUserRoles.push(JSON.parse(newCompanyUser))
                        }
                    }
                })
                
                let companyRoleHierarchyCompanyIds = _.uniqBy(companyRoleHierarchy, 'companyId').map(obj => obj.companyId)
                if (companyRoleHierarchyCompanyIds.includes(parseInt(id))) {
                    if(companyBranchHeadUsers.length > 1){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only have one branch head", life: 3000 }))
                    }

                    if(companyBranchHeadUsers.length === 0 && id != 2){ // removed for indonesia logic should be changed to pmCompanyConfig
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have branch head", life: 3000 }))
                    }
    
                    if(companyRegionalHeadUsers.length > 1){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only have one regional head", life: 3000 }))
                    }

                    if(companyRegionalHeadUsers.length === 0){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have regional head", life: 3000 }))
                    }

                    if(companySeniorKamUsers.length === 0){
                        return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have atleast 1 SR Kam", life: 3000 }))
                    }
                }
                
                delete prevBranchData.shipAddrArr
                delete newBranchData.shipAddrArr
                delete prevBranchData.userRoles
                delete newBranchData.userRoles

                
                let updateCompanyBranch = null
                if(JSON.stringify(prevBranchData, Object.keys(prevBranchData).sort()) !== JSON.stringify(newBranchData, Object.keys(newBranchData).sort())){
                    if(newBranchData.paymentTerms){
                        newBranchData.paymentTerms = JSON.parse(newBranchData.paymentTerms)
                    }
                    
                    updateCompanyBranch = {...newBranchData }
                }

                const stringUserRoles = branchData.userRoles.filter(eachUserRole => eachUserRole.branchId !== 0).map(eachUserRole => { 
                    return {userId: eachUserRole.userId.toString(), statusId: eachUserRole.statusId.toString(), companyRoleId: eachUserRole.companyRoleId.toString(), branchId: eachUserRole.branchId.toString(), companyId: eachUserRole.companyId.toString()} 
                })
                const duplicatesInArray = getDuplicatesInArray(stringUserRoles, ["statusId", "userId", "branchId", "companyRoleId"])
                
                if(duplicatesInArray.length) {
                    return dispatch(raiseToast({ severity: 'error', detail: `Multiple active roles found for a single user` }))
                }

                let confirmMessage = "Do you want to update branch..?"

                let approvalConfirmMessage = ""
                if([2, 3].includes(companyData.buyerSeller)){
                    if(newBranchData.paymentTerms){
                        updateCompanyBranch.isPaymentTermsApproval = handlePaymentTermsApproval(newBranchData.paymentTerms, companyData.paymentTerms)
                    }
                }
                
                if(updateCompanyBranch && !updateCompanyBranch.isPaymentTermsApproval){
                    if(updateCompanyBranch.companyPaymentTerms && !prevBranchData.companyPaymentTerms && relatedPrevBranchPaymentTerms){
                        updateCompanyBranch.isPaymentTermsChanged = true
                        updateCompanyBranch.previousPaymentTerms = relatedPrevBranchPaymentTerms
                    }else if(JSON.stringify(prevBranchData.paymentTerms) !== JSON.stringify(updateCompanyBranch.paymentTerms)){
                        updateCompanyBranch.isPaymentTermsChanged = true
                        updateCompanyBranch.previousPaymentTerms = prevBranchData.companyPaymentTerms ? null : prevBranchData.paymentTerms
                    }
                }

                let updatedCompanyBranchData = {
                    // updatedCompanyUsers,
                    updateCompanyBranch,
                    updateCompanyBranchShipAddr,
                    updateCompanyUserRoles,
                }
                
                if (updateCompanyBranch.isPaymentTermsApproval) {
                    approvalConfirmMessage +=  "This needs approval before seller PO created."
                    if(window.confirm(approvalConfirmMessage)){
                        setSubmitBranchData({ ...branchData, confirmMessage, isUpdateBranch: true })
                        setVisibleApprovalRemarks(true)
                        setUpdateBranchObj(updatedCompanyBranchData)
                    }
                } else{
                    if (window.confirm("Do you want to update branch..?")) {
                        setIsLoaderVisible(true)
                        let updatedBranchData = await updateCompanyBranchData(branchData.branchId, updatedCompanyBranchData)

                        if (updatedBranchData.failure){
                            setIsLoaderVisible(false)
                            return dispatch(raiseToast({ severity: 'error', detail: updatedBranchData.data?.error, life: 3000 }))
                        }else{
                            let updatedBranchDataObj = updatedBranchData.data.companyBranchData ? updatedBranchData.data.companyBranchData : ''
                            
                            if (updatedBranchDataObj) {
                                if (updatedBranchData?.data?.companyBranchShipAddr && updatedBranchData?.data?.companyBranchShipAddr?.length > 0) {
                                    let updatedShipAddrList = []
                                    relatedPrevBranchData?.shipAddrArr.forEach(eachPrevShipAddr => {
                                        const relatedUpdatedshipAddr = updatedBranchData.data.companyBranchShipAddr.find(eachUpdatedAddr => eachUpdatedAddr.shipAddrId === eachPrevShipAddr.shipAddrId)
                                        if(relatedUpdatedshipAddr){
                                            if(relatedUpdatedshipAddr.statusId !== 2){
                                                updatedShipAddrList.push(relatedUpdatedshipAddr)
                                            }
                                        }
                                        else{
                                            updatedShipAddrList.push(eachPrevShipAddr)
                                        }
                                    })
                                    updatedBranchDataObj.shipAddrArr = updatedShipAddrList
                                } else {
                                    updatedBranchDataObj.shipAddrArr = relatedPrevBranchData?.shipAddrArr
                                }
    
                                if (updatedBranchDataObj.vmiEnabled) {
                                    updatedBranchDataObj.vmiEnabled = "Yes"
                                }
                                else {
                                    updatedBranchDataObj.vmiEnabled = "No"
                                }
                                
                                if (!updatedBranchDataObj.paymentTerms) {
                                    if(branchData?.paymentTerms){
                                        updatedBranchDataObj.paymentTerms = JSON.parse(JSON.stringify(branchData.paymentTerms))
                                        updatedBranchDataObj.companyPaymentTerms = true
                                    }
                                } else {
                                    if (updatedBranchDataObj.paymentTerms && typeof updatedBranchDataObj.paymentTerms === 'string') {
                                        updatedBranchDataObj.paymentTerms = JSON.parse(updatedBranchDataObj.paymentTerms)
                                    }
                                }
    
                                let updatedCompanyBranches = companyBranches.map(branch => {
                                    if(branch.branchId === branchData.branchId){
                                        return {...updatedBranchDataObj}
                                    }
                                    return {...branch}
                                })

                                if(updatedBranchData.data.moveShipAddrsList.length){
                                    updatedBranchData.data.moveShipAddrsList.forEach(({ shipAddrId, fromBranchId, toBranch }) => {
                                        const fromBranch = updatedCompanyBranches.find(eachBranch => eachBranch.branchId === fromBranchId)
                                        const toBranchObj = updatedCompanyBranches.find(eachBranch => eachBranch.branchId === toBranch.branchId)
                                    
                                        if (!fromBranch || !toBranchObj) return
                                    
                                        const shipAddrIndex = fromBranch.shipAddrArr.findIndex(eachShipAddr => eachShipAddr.shipAddrId === shipAddrId)
                                        if (shipAddrIndex === -1) return
                                    
                                        const [movedAddr] = fromBranch.shipAddrArr.splice(shipAddrIndex, 1)
                                        movedAddr.branchId = toBranchObj.branchId
                                    
                                        toBranchObj.shipAddrArr.push(movedAddr)
                                    })
                                }
                                
                                setcompanyBranches([...updatedCompanyBranches])
                                setPrevCompanyBranches([...updatedCompanyBranches])
    
                                let newUserRoles = updatedBranchData?.data?.userRoles
                                newUserRoles?.map(role => {
                                    let relatedUser = companyData.companyUsers.find(user => user.userId === role.userId)
                                    if (relatedUser) {
                                        role.user = relatedUser
                                    }
                                    return role
                                })
    
                                let relatedCompanyUserRoles = userRoles?.filter(branch => branch.branchId != branchData.branchId)
                                let relatedBranchUserRoles = userRoles?.filter(eachBranch => eachBranch.branchId === branchData.branchId && typeof(eachBranch.userRoleId) === 'number')
                                
                                let updatedBranchUserRoledIds = []
                                let updatedBranchUsers = relatedBranchUserRoles?.map(eachUserRole => {
                                    updatedBranchUserRoledIds.push(eachUserRole.userRoleId)
                                    let relatedUpdatedBranchUser = newUserRoles?.find(eachRole => eachRole.userRoleId === eachUserRole.userRoleId)
                                    if(relatedUpdatedBranchUser){
                                        return {...relatedUpdatedBranchUser}
                                    }
                                    return {...eachUserRole}
                                })
                                
                                let updatedNewBranchUserRoles = newUserRoles?.filter(eachUserRole => !updatedBranchUserRoledIds.includes(eachUserRole.userRoleId))
                                
                                if(newUserRoles?.length > 0){
                                    setUserRoles([...relatedCompanyUserRoles, ...updatedBranchUsers, ...updatedNewBranchUserRoles])
                                    setPrevUserRoles(JSON.parse(JSON.stringify([...relatedCompanyUserRoles, ...updatedBranchUsers, ...updatedNewBranchUserRoles])))
                                }
                            }else{
                                let updatedCompanyBranches = companyBranches.map(branch => {
                                    if(branch.branchId === branchData.branchId){
                                        branchData.isEditing = false
                                    }
                                    return branch
                                })
                                
                                setcompanyBranches(updatedCompanyBranches)
                            }
                            
                            setIsLoaderVisible(false)
                            setModifiedBranchId(null)
                            return dispatch(raiseToast({ severity: 'success', detail: "Branch data updated successfully" }))
                        }
                    }
                }
            }
        }
    }
    
    const handleSubmitUpdatedBranchWithApproval = async () => {
        const { updateCompanyBranch } = updateBranchObj

        if (updateCompanyBranch.isPaymentTermsApproval && (!paymentTermsApprovalRemarks || (paymentTermsApprovalRemarks && paymentTermsApprovalRemarks?.trim() === ''))) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Enter payment terms approval remarks", life: 3000 }))
        }

        updateCompanyBranch.paymentTermsApprovalRemarks = paymentTermsApprovalRemarks.trim()

        if (window.confirm("Do you want to update branch..?")) {
            setIsLoaderVisible(true)
            let updatedBranchData = await updateCompanyBranchData(updateCompanyBranch.branchId, {...updateBranchObj, updateCompanyBranch})
            console.log("updatedBranchData-response", updatedBranchData)
            if (updatedBranchData?.failure) {
                setIsLoaderVisible(false)
                return dispatch(raiseToast({ severity: 'error', detail: updatedBranchData?.data?.error, life: 3000 }))
            } else {
                let updatedBranchDataObj = updatedBranchData.data.companyBranchData ? updatedBranchData.data.companyBranchData : ''

                if (updatedBranchDataObj) {
                    if (updatedBranchData?.data?.companyBranchShipAddr && updatedBranchData?.data?.companyBranchShipAddr?.length > 0) {
                        updatedBranchDataObj.shipAddrArr = updatedBranchData.data.companyBranchShipAddr
                    } else {

                        let relatedPrevBranchData = prevCompanyBranches.find(branch => branch.branchId === updateBranchObj.branchId)

                        if (relatedPrevBranchData) {
                            updatedBranchDataObj.shipAddrArr = relatedPrevBranchData?.shipAddrArr
                        }
                    }

                    if (updatedBranchDataObj.vmiEnabled) {
                        updatedBranchDataObj.vmiEnabled = "Yes"
                    }
                    else {
                        updatedBranchDataObj.vmiEnabled = "No"
                    }

                    if (!updatedBranchDataObj.paymentTerms) {
                        if (submitBranchData?.paymentTerms) {
                            updatedBranchDataObj.paymentTerms = JSON.parse(JSON.stringify(submitBranchData.paymentTerms))
                            updatedBranchDataObj.companyPaymentTerms = true
                        }
                    } else {
                        if (updatedBranchDataObj.paymentTerms && typeof updatedBranchDataObj.paymentTerms === 'string') {
                            updatedBranchDataObj.paymentTerms = JSON.parse(updatedBranchDataObj.paymentTerms)
                        }
                    }

                    let updatedCompanyBranches = companyBranches.map(branch => {
                        if (branch.branchId === submitBranchData.branchId) {
                            return { ...updatedBranchDataObj }
                        }
                        return { ...branch }
                    })

                    setcompanyBranches([...updatedCompanyBranches])
                    setPrevCompanyBranches([...updatedCompanyBranches])

                    let newUserRoles = updatedBranchData?.data?.userRoles

                    newUserRoles?.map(role => {
                        let relatedUser = companyData.companyUsers.find(user => user.userId === role.userId)
                        if (relatedUser) {
                            role.user = relatedUser
                        }
                        return role
                    })

                    let relatedCompanyUserRoles = userRoles?.filter(branch => branch.branchId != submitBranchData.branchId)
                    let relatedBranchUserRoles = userRoles?.filter(eachBranch => eachBranch.branchId === submitBranchData.branchId && typeof (eachBranch.userRoleId) === 'number')

                    let updatedBranchUserRoledIds = []
                    let updatedBranchUsers = relatedBranchUserRoles?.map(eachUserRole => {
                        updatedBranchUserRoledIds.push(eachUserRole.userRoleId)
                        let relatedUpdatedBranchUser = newUserRoles?.find(eachRole => eachRole.userRoleId === eachUserRole.userRoleId)
                        if (relatedUpdatedBranchUser) {
                            return { ...relatedUpdatedBranchUser }
                        }
                        return { ...eachUserRole }
                    })

                    let updatedNewBranchUserRoles = newUserRoles?.filter(eachUserRole => !updatedBranchUserRoledIds.includes(eachUserRole.userRoleId))

                    if (newUserRoles?.length > 0) {
                        setUserRoles([...relatedCompanyUserRoles, ...updatedBranchUsers, ...updatedNewBranchUserRoles])
                        setPrevUserRoles(JSON.parse(JSON.stringify([...relatedCompanyUserRoles, ...updatedBranchUsers, ...updatedNewBranchUserRoles])))
                    }

                } else {
                    let updatedCompanyBranches = companyBranches.map(branch => {
                        if (branch.branchId === submitBranchData.branchId) {
                            submitBranchData.isEditing = false
                        }
                        return branch
                    })

                    setcompanyBranches(updatedCompanyBranches)
                }

                getApprovalInstances()
                setVisibleApprovalRemarks(false)
                setIsLoaderVisible(false)
                setPaymentTermsApprovalRemarks("")
                return dispatch(raiseToast({ severity: 'success', detail: "Branch data updated successfully" }))
            }
        }
    }

    const handleNewBranchIncrement = async() => {

        const newBranchObj = {
            branchId : uuidv4(),
            branchName : '',
            branchType : '',
            companyId : id,
            statusId : 1,
            vmiEnabled : "No",
            companyPaymentTerms : false,
            paymentTerms : {
                payAdvPO: 0,
                payAdvDelivery: 0,
                payPDCDelivery: 0,
                payOnDelivery: 0,
                payCredit: 0,
                creditPeriodId: null,
            },
            shipAddrArr : [],
            isEditing: true,
            buyerSeller: null
        }

        setcompanyBranches([...companyBranches, {...newBranchObj}])
    }

    const handleRemoveCompanyBranch = async (event, selectedBranchId, selectedBranchName) => {
        event.preventDefault()
        event.stopPropagation()

        if (event.value) {
            let relatedBrandData = companyBranches.find(eachBranch => eachBranch.branchId != selectedBranchId && eachBranch.branchName?.toLowerCase() === selectedBranchName.toLowerCase() && eachBranch.statusId === 1)
            if (relatedBrandData) {
                return dispatch(raiseToast({ severity: "warn", detail: `Cannot activate this branch. Branch ${relatedBrandData.branchName} already exists`, life: 3000 }))
            }
        }

        if(window.confirm(`Are you sure you want to ${event.value ? "activate": "deactivate"} the branch`)){
            if (typeof(selectedBranchId) !== "string") {
                let data = {
                    statusId: event.value ? 1 : 2
                }
                let response = await updateCompanyBranchStatus(selectedBranchId, data)
                if (response) {
                    const updatedCompanyBranches = companyBranches.map(eachBranch => {
                        if(eachBranch.branchId === selectedBranchId){
                            eachBranch.statusId = event.value ? 1 : 2
                        }
                        return eachBranch
                    })
                    setcompanyBranches([...updatedCompanyBranches])
                }
            } else {
                const updatedCompanyBranches = companyBranches.map(eachBranch => {
                    if(eachBranch.branchId === selectedBranchId){
                        eachBranch.statusId = event.value ? 1 : 2
                    }
                    return eachBranch
                })
                setcompanyBranches([...updatedCompanyBranches])
            }
        }
    }

    const handlePaymentTermsChange = (event, branch_id) => {
        const relatedBranch = companyBranches.find(branch => branch.branchId == branch_id)
        if(relatedBranch){
            if(relatedBranch.paymentTerms){
                relatedBranch.paymentTerms[event.target.name] = event.target.value
            }else{
                relatedBranch.paymentTerms = {}
                relatedBranch.paymentTerms[event.target.name] = event.target.value
            }
            
            setcompanyBranches([...companyBranches])
        }
    }

    const handleAddUserRoleToBranch = async (event, branchId) => {
        setUserName(event.value)

        let selectedUserId = event?.value?.userId
        let companyHODRole = companyData.companyRoles.find(role => role.companyRoleId === 3)

        const relatedUser = companyData?.companyUsers?.find(user => user.userId === selectedUserId)

        if (relatedUser) {
            const relatedBranchUserRole = userRoles.filter(eachRole => eachRole.branchId === branchId)
            const relatedHODUserRole = relatedBranchUserRole.find(eachRole => eachRole.companyRoleId === companyHODRole?.companyRoleId)

            const selectedUserBranchUserRole = userRoles.find(eachRole => eachRole.userId === selectedUserId && eachRole.branchId === null)
            if (selectedUserBranchUserRole) {
                selectedUserBranchUserRole.managerId = relatedHODUserRole?.userId
                selectedUserBranchUserRole.branchId = branchId
                selectedUserBranchUserRole.statusId = 1
                selectedUserBranchUserRole.isNew = true

                setUserName(null)
                setUserRoles([...userRoles])
            }
            else {
                
                if (relatedBranchUserRole.length === 0) {
                    if (relatedUser) {
                        relatedUser.statusId = 1
                        let newUserRole = {
                            userRoleId: uuidv4(),
                            branchId: branchId,
                            companyId: relatedUser.companyId,
                            companyRoleId: companyHODRole?.companyRoleId,
                            managerId: null,
                            statusId: 1,
                            userId: relatedUser.userId,
                            user: relatedUser,
                            isNew: true
                        }
                        setUserName(null)
                        setUserRoles([...userRoles, newUserRole])
                    }
                }
                /*else if (!relatedHODUserRole) {
                    setUserName(null)
                    return dispatch(raiseToast({ severity: 'warn', detail: "Please add Branch Head user first", life: 3000 }))
                }*/
                else {
                    if (relatedUser) {
                        let newUserRole = {
                            userRoleId: uuidv4(),
                            branchId: branchId,
                            companyId: relatedUser.companyId,
                            companyRoleId: null,
                            managerId: relatedHODUserRole ? relatedHODUserRole.userId : null,
                            statusId: 1,
                            userId: relatedUser.userId,
                            user: relatedUser,
                            isNew: true
                        }
                        setUserName(null)
                        setUserRoles([...userRoles, newUserRole])
                    }
                }
            }
        }
    }

    const handleManagerChange = async (event, selectedUserId, selectedUserRoleId) => {
        
        const relatedUserRole = userRoles.find(eachRole => eachRole.userRoleId === selectedUserRoleId)
        if(relatedUserRole){
            if(relatedUserRole.userId === event.target.value){
                return dispatch(raiseToast({ severity: 'warn', detail: "User can't be their own manager", life: 3000 }))
            }
        }

        const updatedUserRoles = userRoles.map(eachUserRole => {
            if (eachUserRole.userRoleId === selectedUserRoleId) {
                eachUserRole.managerId = event.target.value
            }
            return eachUserRole
        })
        setUserRoles(updatedUserRoles)
    }

    const handleUserRoleChange = (event, userRoleId) => {
        const relatedUserRole = userRoles.find(eachRole => eachRole.userRoleId === userRoleId)

        if(relatedUserRole){
            if (id == 1){
                let {isPermitted} = checkPermissions({ ...userDetails, permissions: [147] })
                if (isPermitted){
                    //userRole[event.target.name] = event.target.value
                }else if ([2, 11, 48425, 61270, 61269, 61268].includes(event.target.value)){
                    //userRole[event.target.name] = event.target.value
                }else{
                    return dispatch(raiseToast({severity:'error', detail:`Selected User Role Can't be Assigned.`, life: 3000}))
                }
            }
            const updatedUserRoles = userRoles.map(eachUserRole => {
                if(eachUserRole.userRoleId === userRoleId){
                    eachUserRole.companyRoleId = event.target.value
                }
                return eachUserRole
            })
            setUserRoles(updatedUserRoles)
        }
    }

    const handleUserRoleStatusChange = (event, userRoleId, userRole) => {
        // let relatedBranchHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === userRole.companyRoleId && eachRole.companyRoleName === "BRANCH HEAD")
        // if (relatedBranchHeadRole) {
        //     return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only 1 Branch Head", life: 3000 }))
        // }

        // let relatedRegionalHeadRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === userRole.companyRoleId && eachRole.companyRoleName === "REGIONAL HEAD")
        // if (relatedRegionalHeadRole) {
        //     return dispatch(raiseToast({ severity: 'warn', detail: "Company branch can only 1 Regional Head", life: 3000 }))
        // }

        // let relatedSeniorKamRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleId === userRole.companyRoleId && eachRole.companyRoleName === "SR. KAM")
        // if (relatedSeniorKamRole) {
        //     let companySeniorKamUsers = []
        //     if (userRoles && userRoles?.length > 0) {
        //         let relatedSeniorKamRole = companyData.companyRoles.find(eachRole => eachRole.companyRoleName === "SR. KAM")

        //         userRoles.map(eachUser => {
        //             if (eachUser.companyRoleId === relatedSeniorKamRole?.companyRoleId) {
        //                 companySeniorKamUsers.push(eachUser)
        //             }
        //         })
        //     }

        //     if (companySeniorKamUsers.length === 0) {
        //         return dispatch(raiseToast({ severity: 'warn', detail: "Company branch should have atleast 1 SR Kam", life: 3000 }))
        //     }
        // }
        
        const relatedUserRole = userRoles.find(eachRole => eachRole.userRoleId === userRoleId)

        if(relatedUserRole){
            const updatedUserRoles = userRoles.map(eachUserRole => {
                if(eachUserRole.userRoleId === userRoleId){
                    if(event.target.value){
                        eachUserRole.statusId = 1
                    }else{
                        eachUserRole.statusId = 2
                    }
                }
                return eachUserRole
            })
            
            setUserRoles(updatedUserRoles)
        }
    }

    const onClickOpenShippingAddrModal = (branchId) => {
        setVisibleShippingAddress(true) 
        setSelectedBranchId(branchId)
    }

    const setVisibleAddNewShippingAddr = () => {
        setVisibleShippingAddress(false)
        setSelectedBranchId(null)
    }

    const handleCloseApprovalRemarksModel = () => {
        setPaymentTermsApprovalRemarks("")
        setVisibleApprovalRemarks(false)
    }

    const handleTabChange = (event) => {
        if (modifiedBranchId) {
            if (window.confirm("Do you want to discard the changes")) {
                const updatedBranches = companyBranches.map(branch => {
                    if (branch.branchId === modifiedBranchId) {
                        return JSON.parse(JSON.stringify(branch))
                    }
                    else {
                        return branch
                    }
                })

                setModifiedBranchId(null)
                setcompanyBranches(updatedBranches)
                setUserRoles([...prevUserRoles])
            }
            else {
                return
            }
        }
        else {
            setModifiedBranchId(null)
        }
        setActiveIndex(event.index)
    }

    const handlePaymentTermsApproval = (paymentTerms, masterPaymentTerms) => {
        if(!paymentTerms){
            paymentTerms = {
                payAdvPO: 0,
                payAdvDelivery: 0,
                payPDCDelivery: 0,
                payOnDelivery: 0,
                payCredit: 100,
                creditPeriodId: 10
            }
        }
        const isApprovalReq = Object.keys(paymentTerms).some(eachPaymentTerm => {
            if (eachPaymentTerm === 'creditPeriodId') {
                const previousCreditPeriodId = masterPaymentTerms.creditPeriodId ? parseInt(masterPaymentTerms.creditPeriodId) : 0
                if (previousCreditPeriodId > parseInt(paymentTerms[eachPaymentTerm])) {
                    return true
                }
            }
            else if (eachPaymentTerm !== "creditPeriodId" && paymentTerms[eachPaymentTerm] >= 0) {
                let paymentTermNames = ['payAdvPO', 'payAdvDelivery', 'payPDCDelivery', 'payOnDelivery', 'payCredit']

                let paymentTermShortName = eachPaymentTerm
                let previousValue = masterPaymentTerms[paymentTermShortName]

                let masterPaymentTermsPercentagesArr = []
                paymentTermNames.map(termName => {
                    let percentage = masterPaymentTerms[termName]
                    if (percentage) {
                        masterPaymentTermsPercentagesArr.push(percentage)
                    } else {
                        masterPaymentTermsPercentagesArr.push(0)
                    }
                })

                let availablePaymentPercentage = 0
                let previousTermExist = false

                let currentPaymentTermIndex = paymentTermNames.findIndex(term => {
                    if (eachPaymentTerm === term) {
                        return true
                    }
                    return false
                })

                masterPaymentTermsPercentagesArr.map((termPercentage, index) => {
                    if (index <= currentPaymentTermIndex) {
                        availablePaymentPercentage += termPercentage
                        availablePaymentPercentage = parseFloat(parseFloat(availablePaymentPercentage).toFixed(2))
                        if (index < currentPaymentTermIndex) {
                            previousTermExist = true
                        }
                    }
                })

                if (eachPaymentTerm === 'payAdvPO') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > previousValue) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payAdvDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payPDCDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payOnDelivery') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) > availablePaymentPercentage) {
                        return true
                    }
                } else if (eachPaymentTerm === 'payCredit') {
                    if (parseFloat(paymentTerms[eachPaymentTerm]) < previousValue) {
                        return true
                    }
                }
            }
        })

        return isApprovalReq
    }

    const getHeaderTypeClassName = (branch) => {
        const relatedCompanyType = companyTypes.find(
            each => each.companyTypeId === branch.buyerSeller
        )
    
        if(branch.statusId === 2) return 'accordian-inactive-branch'
        if(relatedCompanyType){
            if (relatedCompanyType.companyType === 'Seller') return 'accordian-seller-header'
            if (relatedCompanyType.companyType === 'Buyer') return 'accordian-buyer-header'
        }
        
        return ''
    }

    const accordionHeader = (branch, index) => {
        let branchName = ``
        if (branch.branchName) {
            let buyerSeller = ''
            if (companyData.buyerSeller === 3) {
                const relatedCompanyType = companyTypes.find(eachCompanyType => eachCompanyType.companyTypeId === branch.buyerSeller)
                if (relatedCompanyType) {
                    buyerSeller = `(${relatedCompanyType.companyType})`
                }
            }
            branchName = `${branch.branchName} ${buyerSeller}`
        }
        else {
            branchName = `Branch ${index + 1}`
        }

        let deleteBranchPermissions = []
        if ([1, 3].includes(companyData?.buyerSeller)) {
            deleteBranchPermissions = [164]
        } else {
            deleteBranchPermissions = [165]
        }

        return (
            <span className="flex align-items-center justify-content-between p0 m0">
                <span className="font-bold white-space-nowrap">{branchName}</span>
                <div
                    onClick={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                    }}
                    onMouseDown={(e) => {
                        e.stopPropagation()
                        e.preventDefault()
                    }}
                >
                    <InputSwitchField
                        name="branchStatus"
                        checked={branch.statusId === 1}
                        onChange={(event) => {
                            handleRemoveCompanyBranch(event, branch.branchId, branch.branchName)
                        }}
                        permissions={deleteBranchPermissions}
                        disabled={companyData.statusId === 2}
                    />
                </div>
            </span>
        )
    }

    companyBranches.map((branch) => {
        if(branch.paymentTermAccess == "Yes"){
            let  total_payment = 0
            total_payment +=  parseInt(branch.payAdvPO)  + parseInt(branch.payAdvDelivery)  + parseInt(branch.payPDCDelivery) + parseInt(branch.payOnDelivery)  + parseInt(branch.payCredit) 
            branch.totalPayment = total_payment
        }
    })
    
    let paymentTermsApprovalRemarksVisible = false
    if([2, 3].includes(companyData.buyerSeller)){
        if(submitBranchData.paymentTerms){
            paymentTermsApprovalRemarksVisible = handlePaymentTermsApproval(submitBranchData.paymentTerms, companyData.paymentTerms)
        }
    }

    let addBranchTooltipTxt = ""
    if (companyData.statusId === 2){
        addBranchTooltipTxt = "Add branch is disabled because the company is inactive."
    }
    
    return (
        <div className='container company-branch-page relative'>
            <div className="company-step-header" style={{ top: 50 }}>
                <Steps model={items} activeIndex={2} readOnly={false} />
            </div>
            <div className="p-card mb-3" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                <Toast ref={Toast} />
                <div>
                    <h4 className="mb-2">{companyData?.companyName}</h4>
                </div>
                <Accordion activeIndex={activeIndex} onTabChange={handleTabChange}>
                    {companyBranches.map((branch, index) => {
                        const relatedClientSuccessManager = clientSuccessManagers.find(each => each.userId === branch?.clientSuccessManagerId)
                        const relatedPreviousBranch = prevCompanyBranches.find(eachCompanyBranch => eachCompanyBranch.branchId === branch.branchId)
                        if (relatedClientSuccessManager) {
                            branch.clientSuccessManagerId = relatedClientSuccessManager
                        }

                        return (
                            <AccordionTab key={`branch-${branch.branchId}`} header={()=>accordionHeader(branch, index)} headerClassName={getHeaderTypeClassName(branch)}>
                                <AddBranch
                                    branch={branch}
                                    previousBranch={relatedPreviousBranch}
                                    companyData={companyData}
                                    stateList={stateList}
                                    pinCodesData={pinCodesData}
                                    gstinList={gstinList}
                                    pmCompanyDetails={pmCompanyDetails}
                                    creditPeriods={creditPeriods}
                                    countriesData={countriesData}
                                    userRoles={userRoles}
                                    visibleAddNewShippingAddr={visibleAddNewShippingAddr}
                                    companyBranches={companyBranches}
                                    formErrors={formErrors}
                                    companyId={id}
                                    selectedBranchId={selectedBranchId}
                                    onClickOpenShippingAddrModal={onClickOpenShippingAddrModal}
                                    handleUpdateCompanyBranch={handleUpdateCompanyBranch}
                                    handleAddNewCompanyBranch={handleAddNewCompanyBranch}
                                    handlePaymentTermsChange={handlePaymentTermsChange}
                                    handleManagerChange={handleManagerChange}
                                    validationBranchId={validationBranchId}
                                    setVisibleAddNewShippingAddr={setVisibleAddNewShippingAddr}
                                    handleAddUserRoleToBranch={handleAddUserRoleToBranch}
                                    handleUserRoleChange={handleUserRoleChange}
                                    setVisibleShippingAddress={setVisibleShippingAddress}
                                    setSelectedBranchId={setSelectedBranchId}
                                    setUserRoles={setUserRoles}
                                    prevUserRoles={prevUserRoles}
                                    setModifiedBranchId={setModifiedBranchId}
                                    prefPMStateList={prefPMStateList}
                                    userName = {userName}
                                    handleUserRoleStatusChange = {handleUserRoleStatusChange}
                                    branchManagers = {branchManagers}
                                    approvalInstancesData = {approvalInstancesData}
                                    companyTypes={companyTypes}
                                    setIsLoaderVisible={setIsLoaderVisible}
                                    companyLevelUsers={companyLevelUsers}
                                    relevantKams={relevantKams}
                                    setcompanyBranches={setcompanyBranches}
                                />
                            </AccordionTab>
                        )
                    })}
                </Accordion>
                <div className='mt-3 flex justify-content-start'>
                    <Button className="increment-btn-icon" icon="pi pi-plus-circle" text onClick={handleNewBranchIncrement} size="large" disabled={companyData.statusId === 2} tooltip={addBranchTooltipTxt} tooltipOptions={{position: "top", showOnDisabled: true}} />
                </div>
            </div>

            <Dialog header={"Approval Remarks"} className='mb-3 approval-remark-dialog' visible={visibleApprovalRemarks} onHide={() => handleCloseApprovalRemarksModel()}>
                {
                    paymentTermsApprovalRemarksVisible ?
                        <TextAreaField maxLength={400} name="paymentTermsApprovalRemarks" labelText="Enter remarks for payment terms approval" value={paymentTermsApprovalRemarks} rows={3} onChange={e => setPaymentTermsApprovalRemarks(e.target.value)} />
                        : null
                }
                <div className='flex flex-row justify-content-end'>
                    <Button className="mt-2" label="SUBMIT" outlined onClick={() => { submitBranchData.isUpdateBranch ? handleSubmitUpdatedBranchWithApproval() : handleSubmitNewBranchWithApproval() }} />
                </div>
            </Dialog>
            
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default AddCompanyBranch;
